import Vue from "vue";
import dayjs from "dayjs";

Vue.filter("date", (date, format = "DD.MM.YYYY") => {
  return dayjs(date).format(format);
});
